import { OktaAuth, type TokenParams } from '@okta/okta-auth-js';
import { ENGINE_API_URL, OKTA_BASE_URL, OKTA_CLIENT_ID } from '../constants/platform';
import { isNullOrEmpty } from './guard';
import type { SSOMetadata } from '../types/auth';
import { signOutSSO, signOut } from '../sources/authentication';

export const authClient = new OktaAuth({
    issuer: `${OKTA_BASE_URL}/oauth2/default`,
    clientId: OKTA_CLIENT_ID,
    redirectUri: `${
        ENGINE_API_URL || window.location.origin
    }/api/draw/1/authorization-code/callback`,
    responseType: 'code',
    pkce: false,
});

export const getWithRedirect = async (params?: TokenParams | undefined) => {
    await authClient.token.getWithRedirect(params);
};

export const oktaSignOut = async () => {
    await authClient.signOut();
};

export const getSSOMetadata = () => {
    const cookies = document.cookie.split(';');
    const ssoInfoCookie = cookies.find((value) =>
        value.includes('boomi-flow-sso-metadata-session'),
    );
    if (ssoInfoCookie) {
        const cookieContent = ssoInfoCookie.split('=').pop();
        if (!isNullOrEmpty(cookieContent)) {
            return JSON.parse(decodeURIComponent(cookieContent)) as SSOMetadata;
        }
    }
    return null;
};

export const signOutUser = async (isSso: boolean) => {
    if (isSso) {
        let { redirectUri } = await signOutSSO();
        if (isNullOrEmpty(redirectUri)) {
            redirectUri = '/logged-out';
        }
        window.location.assign(redirectUri);
    } else {
        await signOut();
        await oktaSignOut();
    }
};
